export default __webpack_public_path__ + "static/media/like-icon-white.9469e183.svg";